import { useEffect } from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  url: string;
  filename: string;
}

/**
 * Modal fullscreen com viewer de PDF nativo do browser via <iframe>.
 *
 * Não depende de lib externa: Chrome, Edge, Firefox e Safari renderizam PDF
 * inline quando o MIME é application/pdf — e o próprio viewer do browser já traz
 * os controles de download/print/zoom. Pra documents que NÃO são PDF (docx, xls,
 * etc), use download direto — viewers genéricos exigem conversão server-side,
 * fora do escopo do MVP.
 *
 * Sem header próprio: fecha clicando FORA do PDF (backdrop) ou com ESC. Cliques
 * dentro do iframe (o PDF) não borbulham pro backdrop, então não fecham.
 */
export function PdfPreviewModal({ open, onClose, url, filename }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="force-light fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Visualizador de PDF"
      onClick={onClose}
    >
      <iframe
        src={url}
        title={filename}
        className="h-full w-full max-w-[1200px] rounded-md border border-n-300 bg-n-0"
      />
    </div>
  );
}
